import {AdvertisementConfiguration} from "../models/Models";
import EventPublicApiClientFactory from "../models/EventPublicApiClientFactory";
import React from "react";

interface AdvertisementViewProps {
    advertisementConfig: AdvertisementConfiguration | undefined;
}

const AdvertisementView : React.FC<AdvertisementViewProps> = ({advertisementConfig}) => {

    var screenHeight = window.innerHeight - 80;

    return advertisementConfig ? <div>
        <img src={`${process.env.REACT_APP_API_LOCATION}/api/public/events/${advertisementConfig.eventId}/LiveData/file/${advertisementConfig.fileId}`} style={{maxWidth: '90%', maxHeight: `${screenHeight}px`}} alt={advertisementConfig.text??''} />
    </div> : <div></div>
}

export default AdvertisementView;